export function isPointInVisibleClusterSurface(
  clientX: number,
  clientY: number,
  target: EventTarget | null,
  element: HTMLElement | null
) {
  if (!element) {
    return true;
  }

  if (target instanceof Element && target.closest('[data-resize-handle]')) {
    return true;
  }

  const elementRect = element.getBoundingClientRect();
  const title = element.querySelector<HTMLElement>('.title');
  const cardsContainer = element.querySelector<HTMLElement>('[id^="cards-container_"]');

  if (!title || !cardsContainer) {
    return (
      clientX >= elementRect.left &&
      clientX <= elementRect.right &&
      clientY >= elementRect.top &&
      clientY <= elementRect.bottom
    );
  }

  const titleRect = title.getBoundingClientRect();
  const cardsContainerRect = cardsContainer.getBoundingClientRect();
  const visibleBottom = getVisibleClusterBodyBottom(cardsContainer, cardsContainerRect);

  return (
    clientX >= elementRect.left &&
    clientX <= elementRect.right &&
    clientY >= titleRect.top &&
    clientY <= visibleBottom
  );
}

export function isPointInClusterAddSurface(
  clientX: number,
  clientY: number,
  target: EventTarget | null,
  element: HTMLElement | null
) {
  if (!element) {
    return true;
  }

  if (target instanceof Element && target.closest('[data-resize-handle]')) {
    return false;
  }

  const elementRect = element.getBoundingClientRect();

  return (
    clientX >= elementRect.left &&
    clientX <= elementRect.right &&
    clientY >= elementRect.top &&
    clientY <= elementRect.bottom
  );
}

function getVisibleClusterBodyBottom(cardsContainer: HTMLElement, cardsContainerRect: DOMRect) {
  const childBottoms = Array.from(cardsContainer.children).map(
    (child) => child.getBoundingClientRect().bottom
  );

  if (childBottoms.length === 0) {
    return cardsContainerRect.bottom;
  }

  const paddingBottom = Number.parseFloat(getComputedStyle(cardsContainer).paddingBottom) || 0;
  const contentBottom = Math.max(...childBottoms) + paddingBottom;

  return Math.min(cardsContainerRect.bottom, contentBottom);
}
